import cognito from '../../auth/cognito';

const { jwtToken } = cognito.auth.getSignInUserSession().getIdToken();

const AxiosDefaults = {};

if (jwtToken) {
  console.log('User logged in', jwtToken);
  const defaultConfig = {
    headers: {
      Accept: 'application/json',
      Authorization: `Bearer ${jwtToken}`,
      CacheControl: 'max-age=0,no-cache,no-store,must-revalidate'
    }
  };

  AxiosDefaults.requestConfig = defaultConfig;
} else {
  console.log('User not logged in !');
}

export default AxiosDefaults;
